<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19YBt3M/tc-custom/9781595585363.jpg?1734554851890" alt="This image is the cover for the book World According to Monsanto"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">World According to Monsanto
      </h1>
      <p class="bookDescription body article font2">
        <b>An investigation of the massive agribusiness company, from a winner of the Rachel Carson Prize: </b><b>“Well supported by wide-ranging scientific evidence.” —<i>Kirkus Reviews</i></b><br/>  <br/> The result of a remarkable three-year-long investigation that took award-winning journalist and documentary filmmaker Marie-Monique Robin across four continents, <i>The World According to Monsanto</i> tells the little-known yet shocking story of this agribusiness giant—the world’s leading producer of GMOs (genetically modified organisms)—and how its new “green” face is no less malign than its PCB- and Agent Orange–soaked past.<br/>  <br/> Robin reports that, following its long history of manufacturing hazardous chemicals and lethal herbicides, Monsanto is now marketing itself as a “life sciences” company, seemingly convinced about the virtues of sustainable development. However, Monsanto now controls the majority of the yield of the world’s genetically modified corn and soy—ingredients found in more than 95 percent of American households—and its alarming legal and political tactics to maintain this monopoly are the subject of worldwide concern.<br/>  <br/> Released alongside the documentary film of the same name, <i>The World According to Monsanto</i> is sure to change the way we think about food safety and the corporate control of our food supply.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie-Monique Robin
      </h2>
      
      <p class="authorDescription body article">Marie-Monique Robin is an award-winning French journalist and filmmaker. She received the 1995 Albert-Londres Prize, awarded to investigative journalists in France. She is the director and producer of over thirty documentaries and investigative reports filmed in Latin America, Africa, Europe, and Asia.George Holoch has translated more than twenty books, including Eric Hazan's Notes on the Occupation (The New Press).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Press, The
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e8fa49c4